




























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getCompanyMeasure } from "@/services/api";
import { isEnableAttributionWindow, isEnableAuth } from "@/utils/experiment";
import { normalizeAbtestMeasures } from "@/utils/abtestMeasure";
import { shouldUseAbtestAttributionMetrics } from "@/utils/abtestMetricDisplay";

type HistoryForm = {
  formId?: string;
  name?: string;
  type?: number;
  flowRate?: number;
  participationCnt?: number;
  viewCnt?: number;
  signupCnt?: number;
  orderCnt?: number;
  [key: string]: any;
};

type HistoryRound = {
  roundId?: number;
  roundNo?: number;
  groupName?: string;
  status?: number;
  endReason?: number;
  confirmedWinFormId?: string;
  baselineFormId?: string;
  challengerFormId?: string;
  openTime?: string | number | Date;
  closeTime?: string | number | Date;
  abFormList?: HistoryForm[];
};

@Component
export default class SmartAbHistory extends Vue {
  @Prop({ type: Array, default: () => [] }) rounds!: HistoryRound[];
  @Prop({ type: String, default: "" }) mainFormId!: string;
  /** 嵌在当前轮同一白底容器内：无标题、无独立卡片，轮次间横线分割 */
  @Prop({ type: Boolean, default: false }) embedded!: boolean;
  /** 已结束查看：标题行右侧「开启下一轮」 */
  @Prop({ type: Boolean, default: false }) showNextRound!: boolean;
  /** 与当前轮同一套 FORMABTEST 指标口径 */
  @Prop({ type: Object, default: null }) tableDetail!: { metricDisplayMode?: string } | null;

  get showAttributionMetrics() {
    return shouldUseAbtestAttributionMetrics(this.tableDetail?.metricDisplayMode, isEnableAttributionWindow());
  }

  get enableAuth() {
    return isEnableAuth();
  }

  get columnsMap(): Record<string, string> {
    return {
      viewCnt: this.$tx("brand.monitor.views", "曝光用户数"),
      signupCnt: this.$tx("brand.monitor.submits", "提交用户数"),
      signupRate: this.$tx("form.submitRate", "提交转化率"),
      ...(this.showAttributionMetrics
        ? {
            orderGmv: this.$tx("form.list.col.sales", "销售额"),
            orderCntNew: this.$tx("form.list.col.orders", "订单数"),
            orderAtv: this.$tx("form.list.col.aov", "客单价"),
          }
        : {}),
      orderRate: isEnableAttributionWindow()
        ? this.$tx("form.ab.orderRateIp", "下单转化率（IP）")
        : this.$tx("form.ab.orderRate", "下单转化率"),
      phoneCnt: this.$tx("form.list.col.phone", "收集手机号总量"),
      viewRate: this.$tx("form.ab.impressionRate", "曝光率"),
      orderCnt: isEnableAttributionWindow()
        ? this.$tx("form.ab.orderCntIp", "下单数（IP）")
        : this.$tx("form.ordersPlaced", "下单数"),
      ...(this.enableAuth
        ? {
            loginEmailCnt: this.$tx("form.list.col.loginEmail", "第三方登录收集邮箱总量"),
            loginSignUpCnt: this.$tx("form.list.col.loginSignup", "第三方登录提交用户数"),
          }
        : {}),
    };
  }

  tableColumnsList: string[] = [];

  created() {
    this.tableColumnsList = this.defaultMeasureColumns();
  }

  @Watch("tableDetail", { immediate: true, deep: true })
  refreshMeasureColumns() {
    getCompanyMeasure(
      {
        measureCategory: "FORMABTEST",
      },
      true,
    ).then((res) => {
      const measures = normalizeAbtestMeasures(
        res.data.data.measures || [],
        this.tableDetail?.metricDisplayMode,
        this.showAttributionMetrics,
      );
      this.tableColumnsList = measures?.length ? measures : this.defaultMeasureColumns();
    });
  }

  defaultMeasureColumns() {
    return this.enableAuth
      ? [
          "viewCnt",
          "loginEmailCnt",
          "signupCnt",
          "loginSignUpCnt",
          "signupRate",
          ...(this.showAttributionMetrics ? ["orderGmv", "orderCntNew", "orderAtv"] : ["orderRate"]),
        ]
      : [
          "viewCnt",
          "signupCnt",
          "signupRate",
          ...(this.showAttributionMetrics ? ["orderGmv", "orderCntNew", "orderAtv"] : ["orderRate"]),
        ];
  }

  formatMeasure(_row: HistoryForm, column: { property?: string }, value: unknown) {
    const col = column && column.property ? column.property : "";
    if (value === -1) return "-";
    if (col === "viewCnt" || col === "signupCnt" || col === "phoneCnt" || col === "orderCnt" || col === "orderCntNew") {
      return value == null || value === "" ? "-" : String(value).replace(/\d{1,3}(?=(\d{3})+$)/g, "$&,");
    }
    return value == null || value === "" ? "-" : value;
  }

  get displayRounds() {
    return (this.rounds || []).slice(0, 20);
  }

  rowsOf(item: HistoryRound) {
    const list = item.abFormList || [];
    let hasClose = false;
    for (let i = 0; i < list.length; i++) {
      if (list[i] && list[i].type === null) {
        hasClose = true;
        break;
      }
    }
    return list.map((raw) => {
      const row = { ...raw };
      const userCnt = Number(row.participationCnt) || 0;
      const userViewCnt = Number(row.viewCnt) || 0;
      if (userViewCnt > 0) {
        row.signupRate = row.signupCnt > 0 ? `${((row.signupCnt / userViewCnt) * 100).toFixed(2)}%` : "0";
      } else {
        row.signupRate = "-";
      }
      if (hasClose) {
        if (userCnt > 0) {
          row.orderRate = row.orderCnt > 0 ? `${((row.orderCnt / userCnt) * 100).toFixed(2)}%` : "0";
          row.viewRate = row.viewCnt > 0 ? `${((row.viewCnt / userCnt) * 100).toFixed(2)}%` : "0";
        } else {
          row.orderRate = "-";
          row.viewRate = "-";
        }
      } else {
        if (userViewCnt > 0) {
          row.orderRate = row.orderCnt > 0 ? `${((row.orderCnt / userViewCnt) * 100).toFixed(2)}%` : "0";
        } else {
          row.orderRate = "-";
        }
        if (userCnt > 0) {
          row.viewRate = row.viewCnt > 0 ? `${((row.viewCnt / userCnt) * 100).toFixed(2)}%` : "0";
        } else {
          row.viewRate = "-";
        }
      }
      return row;
    });
  }

  winnerLetter(item: HistoryRound) {
    const winId = item.confirmedWinFormId;
    if (!winId) {
      return "";
    }
    const rows = item.abFormList || [];
    const idx = rows.findIndex((row) => row.formId === winId);
    if (idx === 0) {
      return "A";
    }
    if (idx === 1) {
      return "B";
    }
    if (item.baselineFormId === winId) {
      return "A";
    }
    if (item.challengerFormId === winId) {
      return "B";
    }
    return "";
  }

  resultText(item: HistoryRound) {
    // 需求：1 建议确认 / 2 手动选胜 → 人工选定获胜组；3 → 人工结束
    if (item.endReason === 1 || item.endReason === 2) {
      const tag = this.$tx("form.smartAb.round.manualWinTag", "人工选定获胜组");
      const letter = this.winnerLetter(item);
      return letter ? `${letter} ${tag}` : tag;
    }
    if (item.endReason === 3) {
      return this.$tx("form.smartAb.round.manualEndTag", "人工结束");
    }
    if (item.endReason === 4) {
      return this.$tx("form.smartAb.round.cancelled", "取消草稿");
    }
    if (item.status === 2) {
      const tag = this.$tx("form.smartAb.round.manualWinTag", "人工选定获胜组");
      const letter = this.winnerLetter(item);
      return letter ? `${letter} ${tag}` : tag;
    }
    return "-";
  }

  formatRange(openTime?: string | number | Date, closeTime?: string | number | Date) {
    const fmt = (v?: string | number | Date) => {
      if (!v) return "-";
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return "-";
      const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
      return this.$tx("form.smartAb.datetime", "{y}年{m}月{d}日 {hh}:{mm}")
        .replace("{y}", String(d.getFullYear()))
        .replace("{m}", pad(d.getMonth() + 1))
        .replace("{d}", pad(d.getDate()))
        .replace("{hh}", pad(d.getHours()))
        .replace("{mm}", pad(d.getMinutes()));
    };
    return `${fmt(openTime)} ${this.$tx("form.smartAb.to", "至")} ${fmt(closeTime)}`;
  }

  preview(row: HistoryForm) {
    if (!row.formId || !row.type) return;
    const query = `abtest=true&abtestid=${this.mainFormId || ""}`;
    if (row.type === 1) {
      window.open(`/wheel_of_fortune/setting/${row.formId}?${query}`);
    } else if (row.type === 2) {
      window.open(`/wheel_of_fortune/pop/${row.formId}?${query}`);
    }
  }
}
